import { Plus, X } from "lucide-react";
import { FIELD_CLASS, LABEL_CLASS } from "./shared";

// Size variants (e.g. Junior vs Senior) — each with its own in-stock flag and spec sub-table.
// Pricing deltas are edited in PricingSection, right next to the base Price field.
export const SizesSection = ({ isNew, config, form, addSize, removeSize, updateSize, addSizeSpec, removeSizeSpec, updateSizeSpec }) => {
  if (isNew || !config.hasSizes) return null;
  return (
    <div>
      <span className={LABEL_CLASS}>Size Variants (stock + specs per size — pricing is set above, next to "Price (NZD)")</span>
      <p className="text-white/40 text-xs mt-1 mb-3">
        Only needed for products with size-specific stock/specs (e.g. Junior vs Senior Ground Tents). The FIRST
        size below (order = display order) is the cheapest, priced by the "Price (NZD)" field above — every
        other size's price difference is set in the "+$ for {"{size}"}" box right next to it up there, not
        here. Untick "In Stock" if that specific size has sold out (customers will see it greyed out and
        can't select or buy it, while the other size stays purchasable). Rename/reorder sizes and edit their
        spec tables below.
      </p>

      <div className="space-y-4">
        {form.sizes.map((size, si) => (
          <div key={si} data-testid={`admin-size-${si}`} className="border border-[var(--border-default)] bg-[var(--bg-secondary)]/40 p-4 space-y-3">
            <div className="flex items-center gap-3">
              <input
                data-testid={`admin-size-label-${si}`}
                value={size.label}
                onChange={(e) => updateSize(si, "label", e.target.value)}
                className={FIELD_CLASS + " mt-0 flex-1"}
                placeholder="Size label, e.g. Senior"
              />
              <label className="flex items-center gap-2 text-white/80 text-sm whitespace-nowrap">
                <input
                  data-testid={`admin-size-instock-${si}`}
                  type="checkbox"
                  checked={size.inStock !== false}
                  onChange={(e) => updateSize(si, "inStock", e.target.checked)}
                />
                In Stock
              </label>
              <button type="button" data-testid={`admin-size-remove-${si}`} onClick={() => removeSize(si)} className="text-white/50 hover:text-red-400 shrink-0">
                <X size={16} />
              </button>
            </div>
            <div className="space-y-2 pl-2 border-l border-[var(--border-default)]">
              {size.specs.map(([k, v], pi) => (
                <div key={pi} data-testid={`admin-size-spec-${si}-${pi}`} className="flex items-center gap-2 pl-3">
                  <input value={k} onChange={(e) => updateSizeSpec(si, pi, 0, e.target.value)} className={FIELD_CLASS + " mt-0 flex-1"} placeholder="Label" />
                  <input value={v} onChange={(e) => updateSizeSpec(si, pi, 1, e.target.value)} className={FIELD_CLASS + " mt-0 flex-1"} placeholder="Value" />
                  <button type="button" data-testid={`admin-size-spec-remove-${si}-${pi}`} onClick={() => removeSizeSpec(si, pi)} className="text-white/50 hover:text-red-400 shrink-0">
                    <X size={14} />
                  </button>
                </div>
              ))}
              <button type="button" data-testid={`admin-size-spec-add-${si}`} onClick={() => addSizeSpec(si)} className="pl-3 text-xs font-mono text-white/50 hover:text-[var(--brand-primary)] underline">
                + Add Spec Row
              </button>
            </div>
          </div>
        ))}
      </div>
      <button type="button" data-testid="admin-size-add" onClick={addSize} className="btn-secondary mt-3">
        <Plus size={14} /> Add Size Variant
      </button>
    </div>
  );
};
